import { campaignConditionalValue } from "@signalist/shared-types";

/** The checks a condition step can be created as, from the step picker. */
export type ConditionalNodeKind =
	| "conditional"
	| "linkedinInviteNode"
	| "leadHasEmail"
	| "leadHasLinkedin"
	| "emailOpened"
	| "emailClicked"
	| "leadPriority"
	| "linkedinConnected";

/**
 * The `conditionalValue` a newly added condition step starts with. Shared by the campaign builder
 * and the Outbox's per-lead sequence editor; a generic condition starts as "Lead has email". The
 * labels live in @signalist/shared-types, where the MCP sequence converter writes the same values
 * (PREC-4258).
 */
export const buildConditionalValue = (type?: ConditionalNodeKind) => campaignConditionalValue(type);
